(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-bottom-bar"] && !Shopify.designMode) return;
  try {
    
  if (!window.ctFooterLanguageSelectInitialized) {
    window.ctFooterLanguageSelectInitialized = true;
    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-ct-footer-language-select]')) return;

      var form = event.target.closest('form');
      if (form) form.requestSubmit();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bak"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-preference-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRoot = (root) => {
      if (root.dataset.preferenceQuizInitialized === 'true') return;
      root.dataset.preferenceQuizInitialized = 'true';

      const observerManager = window.ChewTrueIntersectionObserver;
      if (observerManager?.observe) {
        observerManager.observe(root, (entry) => {
          root.classList.toggle('is-bubble-animation-active', entry.isIntersecting);
        }, { threshold: 0 });
      } else {
        root.classList.add('is-bubble-animation-active');
      }

      root.addEventListener('click', (event) => {
        const option = event.target.closest('[data-preference-option]');
        if (option && root.contains(option)) {
          const cloud = option.closest('[data-preference-cloud]');
          if (cloud?.dataset.suppressClick === 'true') {
            event.preventDefault();
            event.stopPropagation();
            cloud.dataset.suppressClick = 'false';
            return;
          }
          selectPreference(option);
          return;
        }

        const dot = event.target.closest('[data-quiz-dot]');
        if (!dot || !root.contains(dot)) return;
        const carousel = dot.closest('[data-quiz-carousel]');
        if (carousel) showSlide(carousel, Number(dot.dataset.quizDot));
      });

      initBubbleDrag(root);

      const carouselTimers = [];
      const carouselVisibilityObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.dataset.carouselVisible = entry.isIntersecting ? 'true' : 'false';
        });
      }, { threshold: 0 }) : null;

      root.querySelectorAll('[data-quiz-carousel]').forEach((carousel) => {
        const slides = carousel.querySelectorAll('[data-quiz-slide]');
        if (slides.length < 2) return;
        carousel.dataset.currentSlide = '0';
        carousel.dataset.carouselVisible = 'true';
        carouselVisibilityObserver?.observe(carousel);
        if (carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const duration = Number(carousel.dataset.carouselDuration) || 5000;
          const timer = window.setInterval(() => {
            if (carousel.dataset.carouselVisible !== 'false') {
              showSlide(carousel, (Number(carousel.dataset.currentSlide) + 1) % slides.length);
            }
          }, duration);
          carouselTimers.push(timer);
        }
      });

      const destroy = () => {
        carouselTimers.forEach((timer) => window.clearInterval(timer));
        carouselVisibilityObserver?.disconnect();
        root.dataset.preferenceQuizInitialized = 'false';
      };

      root._petPreferenceQuizDestroy = destroy;

      function selectPreference(option) {
        root.querySelectorAll('[data-preference-option]').forEach((item) => {
          const selected = item === option;
          item.classList.toggle('is-selected', selected);
        });
        root.dataset.selectedPreference = option.dataset.preferenceValue || '';
      }

      function initBubbleDrag(scope) {
        scope.querySelectorAll('[data-preference-cloud]').forEach((cloud) => {
          let pointerId = null;
          let startX = 0;
          let startY = 0;
          let dragX = 0;
          let dragY = 0;
          let moved = false;
          let pressedOption = null;

          const clamp = (value, min, max) => Math.max(min, Math.min(value, max));
          const setPosition = (x, y) => {
            cloud.style.setProperty('--bubble-drag-x', `${x}px`);
            cloud.style.setProperty('--bubble-drag-y', `${y}px`);
          };

          cloud.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'mouse' && event.button !== 0) return;
            pointerId = event.pointerId;
            startX = event.clientX;
            startY = event.clientY;
            moved = false;
            pressedOption = event.target.closest('[data-preference-option]');
            cloud.dataset.suppressClick = 'false';
            cloud.classList.add('is-dragging');
            cloud.setPointerCapture(pointerId);
          });

          cloud.addEventListener('pointermove', (event) => {
            if (event.pointerId !== pointerId) return;
            const deltaX = event.clientX - startX;
            const deltaY = event.clientY - startY;
            if (Math.abs(deltaX) > 4 || Math.abs(deltaY) > 4) moved = true;

            const viewportWidth = cloud.parentElement.clientWidth;
            const viewportTop = cloud.offsetTop;
            const viewportHeight = cloud.parentElement.clientHeight - viewportTop;
            const boundsX = Math.max(64, cloud.offsetWidth - viewportWidth + 56);
            const boundsY = Math.max(24, cloud.offsetHeight - viewportHeight + 24);
            dragX = clamp(dragX + deltaX, -boundsX, boundsX);
            dragY = clamp(dragY + deltaY, -boundsY, 24);
            startX = event.clientX;
            startY = event.clientY;
            setPosition(dragX, dragY);
          });

          const finishDrag = (event) => {
            if (event.pointerId !== pointerId) return;
            if (moved) {
              cloud.dataset.suppressClick = 'true';
            } else if (pressedOption) {
              selectPreference(pressedOption);
              const optionHref = pressedOption.getAttribute('href');
              if (optionHref && optionHref !== '#') {
                window.location.assign(pressedOption.href);
              }
            }
            pressedOption = null;
            cloud.classList.remove('is-dragging');
            if (cloud.hasPointerCapture(pointerId)) cloud.releasePointerCapture(pointerId);
            pointerId = null;
          };

          cloud.addEventListener('pointerup', finishDrag);
          cloud.addEventListener('pointercancel', finishDrag);
        });
      }

      function showSlide(carousel, index) {
        const slides = carousel.querySelectorAll('[data-quiz-slide]');
        const dots = carousel.querySelectorAll('[data-quiz-dot]');
        if (!slides.length) return;
        const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          if (active) loadSlideMedia(slide);
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === nextIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        carousel.dataset.currentSlide = String(nextIndex);
      }

      function loadSlideMedia(slide) {
        const image = slide.querySelector('[data-ct-deferred-media="image"]');
        const imageUrl = slide.dataset.ppqSlideImage;
        if (!image || !imageUrl) return;

        if (window.ChewTrueDeferredMedia?.load) {
          window.ChewTrueDeferredMedia.load(image);
        } else {
          if (image.dataset.src) image.setAttribute('src', image.dataset.src);
          if (image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
          if (image.dataset.sizes) image.setAttribute('sizes', image.dataset.sizes);
        }
        slide.style.setProperty('--ppq-slide-image', `url("${imageUrl}")`);
      }
    };

    const getRoots = (target) => {
      const roots = [];
      if (target.matches?.('[data-pet-preference-quiz]')) roots.push(target);
      roots.push(...target.querySelectorAll('[data-pet-preference-quiz]'));
      return roots;
    };

    getRoots(document).forEach(initRoot);

    document.addEventListener('shopify:section:load', (event) => {
      getRoots(event.target).forEach(initRoot);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      getRoots(event.target).forEach((root) => {
        root._petPreferenceQuizDestroy?.();
        delete root._petPreferenceQuizDestroy;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
